import layoutActions from "actions/layout";
import { connect } from "helpers/redux";

export default function (Component) {
    const mapState = (state) => ({
        profile: state.profile.profile,
        roles: state.profile.roles,
        sidebarOpened: state.layout.sidebarOpened,
        links: state.layout.links,
        organization: state.profile.organization,
    });

    const mapDispatch = (dispatch) => ({
        toggleSidebar: (params) => dispatch(layoutActions.toggleSidebar(params)),
    });

    return connect(mapState, mapDispatch)(Component);
}
